import { render, staticRenderFns } from "./ContabilitaFatturazioneEdit.vue?vue&type=template&id=311c8279"
import script from "./ContabilitaFatturazioneEdit.vue?vue&type=script&lang=js"
export * from "./ContabilitaFatturazioneEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports